import React from 'react';
import { Home, Copy } from 'lucide-react';
import { Unidade, dangerButtonStyle } from './types';

interface UnidadesAvulsasViewProps {
    unidades: Unidade[];
    validateUnidade: (unidade: Unidade) => { isValid: boolean; isPartial: boolean };
    openUnidadeEditor: (ref: { type: 'avulsa', unidadeIndex: number }) => void;
    removeUnidadeAvulsa: (index: number) => void;
    selectedUnits: Map<string, any>;
    sourceCoords: any;
    handleUnitSelection: (key: string, coords: any) => void;
    handleSetSource: () => void;
    handleApplyToSelected: () => void;
    handleClearSelection: () => void;
    handleSelectAllAvulsas: () => void;
}

const UnidadesAvulsasView: React.FC<UnidadesAvulsasViewProps> = ({
    unidades,
    validateUnidade,
    openUnidadeEditor,
    removeUnidadeAvulsa,
    selectedUnits,
    sourceCoords,
    handleUnitSelection,
    handleSetSource,
    handleApplyToSelected,
    handleClearSelection,
    handleSelectAllAvulsas
}) => {
    return (
        <div>
            {/* --- Ações de Cópia --- */}
            {(selectedUnits.size > 0 || sourceCoords) && (
                <div className="my-4 p-3 bg-gray-100 rounded-md flex items-center space-x-4 border border-gray-200">
                    <p className="font-semibold text-gray-800">Ações de Cópia:</p>
                    {!sourceCoords ? (
                        <button 
                            onClick={handleSetSource} 
                            disabled={selectedUnits.size !== 1}
                            className="px-3 py-1 bg-blue-500 text-white text-xs font-bold rounded-md disabled:bg-gray-400 flex items-center gap-2"
                        >
                            <Copy size={14} /> Usar como Modelo
                        </button>
                    ) : (
                        <>
                             <button 
                                onClick={handleSelectAllAvulsas}
                                className="px-3 py-1 bg-blue-500 text-white text-xs font-bold rounded-md flex items-center gap-2"
                            >
                                Selecionar Todas
                            </button>
                            <button 
                                onClick={handleApplyToSelected} 
                                disabled={selectedUnits.size === 0}
                                className="px-3 py-1 bg-green-600 text-white text-xs font-bold rounded-md disabled:bg-gray-400"
                            >
                                Aplicar para {selectedUnits.size} selecionados
                            </button>
                        </>
                    )}
                    <button onClick={handleClearSelection} className="px-3 py-1 bg-red-500 text-white text-xs font-bold rounded-md">
                        Limpar Seleção
                    </button>
                </div>
            )}
            <div className="space-y-3">
            {unidades.map((unidade, index) => {
                const { isValid, isPartial } = validateUnidade(unidade);
                let statusColor = !isPartial ? 'border-gray-300' : (isValid ? 'border-emerald-500' : 'border-red-500');
                if (unidade.confirmada === false) {
                    statusColor = 'border-yellow-400';
                }

                const unitKey = `avulsa-${index}`;
                const coords = { type: 'avulsa', unidadeIndex: index };
                const isSelected = selectedUnits.has(unitKey);
                const isSource = sourceCoords && sourceCoords.type === 'avulsa' && sourceCoords.unidadeIndex === index;

                return (
                    <div key={index} onClick={() => sourceCoords ? handleUnitSelection(unitKey, coords) : openUnidadeEditor({ type: 'avulsa', unidadeIndex: index })} className={`group relative flex items-center justify-between p-3 border-l-4 ${statusColor} bg-white shadow-sm rounded-md cursor-pointer hover:shadow-md transition-shadow`}>
                        <div className="flex items-center gap-3">
                            <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => handleUnitSelection(unitKey, coords)}
                                className="h-4 w-4 z-10 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                disabled={isSource}
                                onClick={e => e.stopPropagation()}
                            />
                            <Home className="text-gray-600" />
                            <span className="font-medium text-gray-800">{unidade.nome || `Nova Unidade Avulsa ${index + 1}`}</span>
                        </div>
                        <div className="flex items-center space-x-2">
                            <button type="button" onClick={(e) => { e.stopPropagation(); removeUnidadeAvulsa(index); }} className={dangerButtonStyle}>Remover</button>
                        </div>
                    </div>
                )
            })}
            {unidades.length === 0 && <p className="text-sm text-gray-500">Nenhuma unidade avulsa adicionada.</p>}
        </div>
        </div>
    );
};

export default UnidadesAvulsasView;